import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {OAuthCallbackComponent} from './oauth-callback.component';
import {HomePageComponent} from './home-page/home-page.component';
import {WholesaleCommitmentByZoneComponent} from './wholesale-commitment-by-zone/wholesale-commitment-by-zone.component';
import {WholesaleDealerCommitmentComponent} from './wholesale-dealer-commitment/wholesale-dealer-commitment.component';
import {WholesaleDealerCommitmentHistory} from './wholesale-dealer-commitment-history/wholesale-dealer-commitment-history.component';
import {OAuthCallbackLocalComponent} from './oauth-callback-local.component';
import {LogoutPageComponent} from './logout-page/logout-page.component';
import {DealerMixVolumeComponent} from './dealer-mix-volume/dealer-mix-volume.component';
import {CommitmentAuditTrailComponent} from './commitment-audit-trail/commitment-audit-trail.component';
import {MsalGuard, MsalRedirectComponent} from '@azure/msal-angular';
import {BrowserUtils} from '@azure/msal-browser';
import 'tslib'; // Add import statement for 'tslib' module


const routes: Routes = [
	{
		path: '',
		redirectTo: '/home-page',
		pathMatch: 'full'
	},
	//{ path: '', redirectTo: '/oauth-callback', pathMatch: 'full' },
	{
		path: 'home-page',
		component: HomePageComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'logout',
		component: LogoutPageComponent
	},
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: 'oauth-callback',
		component: OAuthCallbackLocalComponent
	},
	{
		path: 'access_token',
		component: OAuthCallbackComponent
	},
	{
		path: 'wholesale-by-zone',
		component: WholesaleCommitmentByZoneComponent, canActivate: [MsalGuard]
	},
	{
		path: 'CommitmentAudit',
		component: CommitmentAuditTrailComponent, canActivate: [MsalGuard]
	},
	{
		path: 'wholesaleDealerCommitment',
		component: WholesaleDealerCommitmentComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'WholesaleDealerCommitmentHistory',
		component: WholesaleDealerCommitmentHistory,
		canActivate: [MsalGuard]
	},
	{
		path: 'dealer-mix-volume',
		component: DealerMixVolumeComponent, canActivate: [MsalGuard]
	},

	{
		path: '**',
		component: HomePageComponent, canActivate: [MsalGuard]
	}

];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule],
	providers: []
})
export class AppRoutingModule {
}
